
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 .5V2h6V.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5V2h1c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H3c-1.125 0-2-.875-2-2V4c0-1.094.875-2 2-2h1V.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5zM2 6v8c0 .563.438 1 1 1h10c.531 0 1-.438 1-1V6H2zm1-3c-.563 0-1 .469-1 1v1h12V4c0-.531-.469-1-1-1H3zm1.25 5a.246.246 0 00-.25.25v2.5c0 .156.094.25.25.25h2.5c.125 0 .25-.094.25-.25v-2.5A.269.269 0 006.75 8h-2.5zM3 8.25C3 7.562 3.531 7 4.25 7h2.5C7.438 7 8 7.563 8 8.25v2.5C8 11.469 7.437 12 6.75 12h-2.5C3.531 12 3 11.469 3 10.75v-2.5z","fill":"#212121"}})])
          )
        }
      }
    